var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      ref: "modal",
      attrs: {
        showCloseBtn: false,
        modalId: _vm.modalId,
        modalType: _vm.modalType,
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "content" }, slot: "content" },
        [
          _vm._t("content", function () {
            return [
              _vm._l(_vm.formData, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "modal-container" },
                  [
                    item.type === "text"
                      ? _c("div", [
                          _c(
                            "label",
                            {
                              staticClass: "tender-font emphasis",
                              class: { "required-flag": item.required },
                            },
                            [_vm._v(_vm._s(item.label))]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formData[index].value,
                                expression: "formData[index].value",
                              },
                            ],
                            class: {
                              "error-highlight":
                                _vm.validateHighlight[index] &&
                                item.required &&
                                _vm.isEmptyValue(_vm.formData[index].value),
                            },
                            attrs: { type: "text", required: item.required },
                            domProps: { value: _vm.formData[index].value },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.formData[index],
                                    "value",
                                    $event.target.value
                                  )
                                },
                                function ($event) {
                                  return _vm.setValidateHighlight(index)
                                },
                              ],
                            },
                          }),
                        ])
                      : item.type === "multiSelect"
                      ? _c(
                          "div",
                          { staticClass: "multi-select" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "tender-font emphasis",
                                class: { "required-flag": item.required },
                              },
                              [_vm._v(_vm._s(item.label))]
                            ),
                            _vm._v(" "),
                            _c("HKLSelect", {
                              class: {
                                "error-highlight":
                                  _vm.validateHighlight[index] &&
                                  item.required &&
                                  _vm.isEmptyValue(_vm.formData[index].value),
                              },
                              attrs: {
                                value: _vm.formData[index].value || undefined,
                                options: _vm.getMultiSelectHklOptions(item),
                                showSearch: true,
                                required: item.required,
                                placeholder: "",
                              },
                              on: {
                                change: function (val) {
                                  return _vm.onMultiSelectChange(index, val)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.errHint
                ? _c(
                    "span",
                    { staticClass: "form-error is-visible appr-error-message" },
                    [_vm._v("\n        " + _vm._s(_vm.errHint) + "\n      ")]
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
        _c(
          "button",
          {
            staticClass: "btn btn--darkblue",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.close()
              },
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.cancelBtnName) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn--orange",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.confirm()
              },
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.confirmBtnName) + "\n    ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }